import { forwardRef, type SVGProps } from 'react';

export interface LineHeightIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const LineHeightIcon = forwardRef<SVGSVGElement, LineHeightIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path
      d="M8 4.598C8.259 4.599 8.51 4.679 8.721 4.829 8.931 4.979 9.09 5.191 9.174 5.435L10.865 10.32C10.967 10.614 10.811 10.934 10.517 11.036 10.224 11.137 9.904 10.981 9.802 10.688L9.471 9.733H6.528L6.198 10.688C6.097 10.981 5.776 11.137 5.483 11.036 5.189 10.934 5.033 10.614 5.135 10.32L6.826 5.435 6.861 5.345C6.951 5.139 7.095 4.96 7.279 4.829 7.489 4.679 7.742 4.598 8 4.598ZM8 5.723C7.976 5.723 7.952 5.731 7.932 5.745 7.912 5.76 7.897 5.78 7.889 5.803L6.918 8.608H9.082L8.111 5.803C8.103 5.779 8.088 5.76 8.068 5.745 8.048 5.731 8.025 5.724 8 5.723ZM2.563 2H13.5C13.776 2 14 2.252 14 2.563 14 2.873 13.776 3.125 13.5 3.125H2.563C2.252 3.125 2 2.873 2 2.563 2 2.252 2.252 2 2.563 2ZM2.5 12.875H13.5C13.776 12.875 14 13.127 14 13.438 14 13.748 13.776 14 13.5 14H2.5C2.224 14 2 13.748 2 13.438 2 13.127 2.224 12.875 2.5 12.875Z"
      fill="currentColor"
    />
  </svg>
));

LineHeightIcon.displayName = 'LineHeightIcon';
